import React from "react";
import styled, { css } from "styled-components";

import colors from "core/colors";
import Heading from "core/Heading";
import Button from "core/Button";
import BodyText from "core/BodyText";
import Messages from "core/Messages";
import Link from "core/Link";
import Avatar from "core/Avatar";
import breakpoints from "core/breakpoints";

import { BannerBodyText, LeftIconContainer } from "core/Messages/styles";

import { convertPxToRem } from "frontend/components/helpers";

export const LicenseInfo = styled.div`
    color: ${colors.secondary.dolphin};
`;

export const IconInfo = styled(BodyText).attrs({
    type: "p",
    copyColor: colors.primary.diamond,
    size: "sm"
})``;

export const DownloadMessage = styled(Messages).attrs({
    infoType: "success",
    darkMode: true
})`
    ${LeftIconContainer} {
        top: 0;
    }

    ${BannerBodyText} {
        color: ${colors.alternative.lightMode.chartreuse};
    }
`;

export const CollectionTitle = styled(({ children, className }) => (
    <Heading
        className={className}
        size="md"
        type="h1"
        headingColor={colors.primary.diamond}
    >
        {children} Icon Set
    </Heading>
))``;

export const CreatorName = styled(({ href, className, children }) => (
    <Link
        className={className}
        href={href}
        size="xl"
        styleType="secondary"
        display="inline"
        darkMode
        disableVisitedStyle
    >
        <Heading size="sm" headingColor={colors.primary.diamond}>
            {children}
        </Heading>
    </Link>
))``;

export const CreatorAvatar = styled(({ href, avatarSrc, alt, className }) => (
    <a href={href} className={className}>
        <Avatar alt={alt} src={avatarSrc} />
    </a>
))(
    () => css`
        & ${Avatar} {
            @media (min-width: 60rem) and (max-width: ${
                breakpoints.beforeDesktop.rem
            }) {
                height: ${convertPxToRem(35)}
                width: ${convertPxToRem(35)}
            }
        }
    `
);

export const CreatorCountry = styled(Heading).attrs({
    size: "xs",
    headingColor: colors.primary.diamond
})``;

export const CreatorNameAndCountryLayout = styled.div`
    display: flex;
    align-items: baseline;
`;

export const CreatorInfoLayout = styled.div`
    display: flex;
    align-items: center;

    & ${CreatorName} {
        display: inline-block;
        margin-left: ${convertPxToRem(16)};
    }

    & ${CreatorCountry} {
        margin-left: ${convertPxToRem(10)};
    }
`;

export const GeneralInfo = styled.div``;

export const Cta = styled(Button).attrs({
    styleType: "cta",
    darkMode: true,
    width: "100%"
})`
    &[aria-disabled="true"]:focus {
        outline: none;
        box-shadow: none;
    }
`;

export const BuyBoxLayout = styled.div`
    & ${CollectionTitle} {
        margin-bottom: ${convertPxToRem(16)};
    }

    & ${CreatorInfoLayout} {
        margin-bottom: ${convertPxToRem(8)};
    }

    & ${DownloadMessage} {
        margin-bottom: ${convertPxToRem(8)};
    }

    & ${GeneralInfo}:not(:last-child) {
        margin-bottom: ${convertPxToRem(24)};
    }
`;
